export default __webpack_public_path__ + "static/media/spain-square.3b3c1e35.png";